"use client";

import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import Image from "next/image";
import { P, Title } from "@motorata/base-ui.components.atoms.typography";
import List from "@motorata/base-ui.components.molecules.list";
import Button from "@motorata/base-ui.components.atoms.button";
import { blockStyles } from "@motorata/base-ui.components.atoms._atoms";
import TextHTML from "@motorata/base-ui.components.atoms.text-html";
import Counters from "../common/Counters";

const TextWithImage = ({
   id,
   label,
   reverse,
   title,
   text,
   textHtml,
   list = [],
   counters = [],
   image,
   button,
   rotateY,
   background,
   children
 }: {
  id?: string
  label?: string
  reverse?: boolean
  title?: string
  text?: string
  textHtml?: string
  image?: string
  button?: {
    icon: string
    title: string
  }
  background?: string
  rotateY?: number
  list?: string[]
  counters?: {
    count: string
    text: string
  }[]
  children?: ReactNode
}) => {
  return (
    <Wrapper id={id} background={background} reverse={reverse}>
      <TextWrapper isImage={!!image}>
        <Title label={label} elementType="label">{title}</Title>
        {
          text && <P small marginBottom="M">
            {text}
          </P>
        }
        {textHtml && <TextHTML content={textHtml} />}
        {list.length > 0 && <List list={list} />}
        {counters.length > 0 && <Counters list={counters} />}
        {button && (
          <Button marginTop="M" icon={button.icon}>
            {button.title}
          </Button>
        )}
        {children}
      </TextWrapper>
      {image && (
        <ImageWrapper rotateY={rotateY}>
          <Image priority={true} alt={`Grafika ${title}`} fill src={image} />
        </ImageWrapper>
      )}
    </Wrapper>
  );
};

export default TextWithImage;

const ImageWrapper = styled.div`
  width: 50%;
  position: relative;
  height: 400px;

  img {
    margin: 0;
    object-fit: contain;
    filter: drop-shadow(5px 5px 30px rgba(0, 0, 0, 0.1));
    transform: scaleX(1) scaleY(1) scaleZ(1) rotateX(0deg) rotateY(${({ rotateY }) => rotateY}) rotateZ(0deg) translateX(0px) translateY(0px) translateZ(0px) skewX(0deg) skewY(0deg);
  }
`;

const TextWrapper = styled.div`
  width: ${({ isImage }) => (!isImage ? "100%" : "40%")};

  p, li {
    font-size: ${({ theme }) => theme.font.M} !important;
  }
`;

const Wrapper = styled.div`
  ${blockStyles};
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  grid-gap: ${({ theme }) => theme.space.M};

  ${({ reverse }) =>
          reverse &&
          css`
            flex-direction: row-reverse;
          `};

  @media (max-width: 900px) {
    flex-direction: column;
    > div {
      width: 100%;
    }
  }
`;
